import {AppDispatch} from "../index"
import $api from "../../axios"
import {brigadeSlice} from "../slices/brigadeSlice"
import {IFetchBrigadeParams, IBrigade, IBrigadeListPayload} from "../../models/brigade"

export const fetchBrigades = (params: IFetchBrigadeParams) => async (dispatch: AppDispatch) => {
  try {
    dispatch(brigadeSlice.actions.fetching())
    const response = await $api.get<IBrigadeListPayload>('brigade/brigade/index', {
      params
    })
    dispatch(brigadeSlice.actions.fetchSuccess(response.data))
  } catch (e: any) {
    dispatch(brigadeSlice.actions.fetchError(e))
  }
}

export const createBrigade = (data: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(brigadeSlice.actions.creating())
    const response = await $api.post<IBrigade>("brigade/brigade/create", data)
    dispatch(brigadeSlice.actions.createSuccess(response.data))
    return response.data.id
  } catch (e: any) {
    if (e.response.status === 422) {
      console.log(e.response.data)
      dispatch(brigadeSlice.actions.saveError(e.response.data))
    }
  }
}

export const updateBrigade = (data: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(brigadeSlice.actions.updating())
    await $api.put("brigade/brigade/update", data)
    dispatch(brigadeSlice.actions.updateSuccess())
    return true
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(brigadeSlice.actions.saveError(e.response.data))
    }
  }
}

export const deleteBrigade = (brigade_id: number) => async (dispatch: AppDispatch) => {
  try {
    await $api.delete("brigade/brigade/delete", {
      params: {brigade_id}
    })
    return true
  } catch (e: any) {
    console.log(e)
  }
}

export const getBrigadeStatuses = () => async (dispatch: AppDispatch) => {
  try {
    const response = await $api.get("brigade/brigade/get-statuses")
    dispatch(brigadeSlice.actions.getStatuses(response.data))
  } catch (e: any) {
    console.log(e)
  }
}

export const setCurrentPage = (pageNumber: number) => (dispatch: AppDispatch) => {
  dispatch(brigadeSlice.actions.setCurrentPage(pageNumber))
}